import { ModelMessage, ButtonType, MessageFactory, UID_BYTES_PER_ELEMENT, UID_SAFE_BYTES_PER_ELEMENT, calcArrayByteLength, BusMessage, BOOLEAN_BYTES_PER_ELEMENT } from "flavr-common";
export class PickupGrabbableMessage extends ModelMessage {
    get byteLength() {
        return PickupGrabbableMessage.MAX_BYTE_LENGTH;
    }
    constructor(uid = 0) {
        super(uid);
        this.uid = uid;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
    }
    static is(msg) {
        return msg.type === PickupGrabbableMessage.typestatic;
    }
}
PickupGrabbableMessage.typestatic = "PickupGrabbableMessage";
PickupGrabbableMessage.subjectstatic = "interaction";
PickupGrabbableMessage.MAX_BYTE_LENGTH = UID_BYTES_PER_ELEMENT;
MessageFactory.register(PickupGrabbableMessage);
export class MoveGrabbableMessage extends ModelMessage {
    get byteLength() {
        return MoveGrabbableMessage.MAX_BYTE_LENGTH;
    }
    constructor(uid = 0, position = [0, 0, 0], orientation = [0, 0, 0, 1], scale = [1, 1, 1], needTransformUpdate = true) {
        super(uid);
        this.uid = uid;
        this.position = position;
        this.orientation = orientation;
        this.scale = scale;
        this.needTransformUpdate = needTransformUpdate;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
        this.position = stream.number3(this.position);
        this.orientation = stream.number4(this.orientation);
        this.scale = stream.number3(this.scale);
        this.needTransformUpdate = stream.boolean(this.needTransformUpdate);
    }
    static is(msg) {
        return msg.type === MoveGrabbableMessage.typestatic;
    }
}
MoveGrabbableMessage.typestatic = "MoveGrabbableMessage";
MoveGrabbableMessage.subjectstatic = "interaction";
MoveGrabbableMessage.MAX_BYTE_LENGTH = UID_BYTES_PER_ELEMENT + // uid
    Float32Array.BYTES_PER_ELEMENT * 3 + // position
    Float32Array.BYTES_PER_ELEMENT * 4 + // orientation
    Float32Array.BYTES_PER_ELEMENT * 3 + // scale
    BOOLEAN_BYTES_PER_ELEMENT; // needTransformUpdate
MessageFactory.register(MoveGrabbableMessage);
export class ReleaseGrabbableMessage extends ModelMessage {
    get byteLength() {
        return PickupGrabbableMessage.MAX_BYTE_LENGTH;
    }
    constructor(uid = 0) {
        super(uid);
        this.uid = uid;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
    }
    static is(msg) {
        return msg.type === ReleaseGrabbableMessage.typestatic;
    }
}
ReleaseGrabbableMessage.typestatic = "ReleaseGrabbableMessage";
ReleaseGrabbableMessage.subjectstatic = "interaction";
ReleaseGrabbableMessage.MAX_BYTE_LENGTH = UID_BYTES_PER_ELEMENT;
MessageFactory.register(ReleaseGrabbableMessage);
/**
 * Sets the controller button action mapping used by interaction systems.
 */
export class SetControllerButtonActionsMessage extends BusMessage {
    get byteLength() {
        return (Uint8Array.BYTES_PER_ELEMENT + // button
            calcArrayByteLength(this.actions.onClick) + // onClick
            calcArrayByteLength(this.actions.onDoubleClick) + // onDoubleClick
            calcArrayByteLength(this.actions.onHold) + // onHold
            calcArrayByteLength(this.actions.onHoldReleased)); // onHoldReleased
    }
    constructor(button = ButtonType.CLICK, actions = {}) {
        super();
        this.button = button;
        this.actions = actions;
    }
    serialization(stream) {
        this.button = stream.uint8(this.button);
        if (stream.isReading)
            this.actions = {};
        this.actions.onClick = stream.arraySafe(this.actions.onClick);
        this.actions.onDoubleClick = stream.arraySafe(this.actions.onDoubleClick);
        this.actions.onHold = stream.arraySafe(this.actions.onHold);
        this.actions.onHoldReleased = stream.arraySafe(this.actions.onHoldReleased);
    }
    static is(msg) {
        return msg.type === SetControllerButtonActionsMessage.typestatic;
    }
}
SetControllerButtonActionsMessage.typestatic = "SetControllerButtonActionsMessage";
SetControllerButtonActionsMessage.subjectstatic = "interaction";
MessageFactory.register(SetControllerButtonActionsMessage);
/**
 * Resets controller button actions back to their defaults.
 */
export class ResetControllerButtonActionsMessage extends BusMessage {
    get byteLength() {
        return 0;
    }
    serialization({}) { }
    static is(msg) {
        return msg.type === ResetControllerButtonActionsMessage.typestatic;
    }
}
ResetControllerButtonActionsMessage.typestatic = "ResetControllerButtonActionsMessage";
ResetControllerButtonActionsMessage.subjectstatic = "interaction";
MessageFactory.register(ResetControllerButtonActionsMessage);
/**
 * Publishes the speech commands that are currently available for interactions.
 */
export class SetAvailableSpeechCommandsMessage extends BusMessage {
    get byteLength() {
        return calcArrayByteLength(this.commands);
    }
    constructor(commands = []) {
        super();
        this.commands = commands;
    }
    serialization(stream) {
        this.commands = stream.array(this.commands);
    }
    static is(msg) {
        return msg.type === SetAvailableSpeechCommandsMessage.typestatic;
    }
}
SetAvailableSpeechCommandsMessage.typestatic = "SetAvailableSpeechCommandsMessage";
SetAvailableSpeechCommandsMessage.subjectstatic = "interaction";
MessageFactory.register(SetAvailableSpeechCommandsMessage);
/**
 * Announces that a model was clicked.
 */
export class ModelClickedMessage extends BusMessage {
    get byteLength() {
        return (UID_BYTES_PER_ELEMENT + // uid
            UID_BYTES_PER_ELEMENT + // controllerUid
            Float32Array.BYTES_PER_ELEMENT * 3 + // hitPoint
            Float32Array.BYTES_PER_ELEMENT * 3); // localPoint
    }
    constructor(uid, controllerUid, hitPoint, localPoint) {
        super();
        this.uid = uid;
        this.controllerUid = controllerUid;
        this.hitPoint = hitPoint;
        this.localPoint = localPoint;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
        this.controllerUid = stream.uid(this.controllerUid);
        this.hitPoint = stream.number3(this.hitPoint);
        this.localPoint = stream.number3(this.localPoint);
    }
    static is(msg) {
        return msg.type === ModelClickedMessage.typestatic;
    }
}
ModelClickedMessage.typestatic = "ModelClickedMessage";
ModelClickedMessage.subjectstatic = "interaction";
MessageFactory.register(ModelClickedMessage);
/**
 * Announces that no model was clicked.
 */
export class NoModelClickedMessage extends BusMessage {
    serialization(_stream) { }
    static is(msg) {
        return msg.type === NoModelClickedMessage.typestatic;
    }
}
NoModelClickedMessage.typestatic = "NoModelClickedMessage";
NoModelClickedMessage.subjectstatic = "interaction";
MessageFactory.register(NoModelClickedMessage);
/**
 * Announces that a model is hovered in a UI context.
 */
export class ModelHoveredInUIMessage extends BusMessage {
    get byteLength() {
        return (UID_SAFE_BYTES_PER_ELEMENT + // uid
            UID_BYTES_PER_ELEMENT); // controllerUid
    }
    constructor(modelUid, controllerUid) {
        super();
        this.modelUid = modelUid;
        this.controllerUid = controllerUid;
    }
    serialization(stream) {
        this.modelUid = stream.uidSafe(this.modelUid);
        this.controllerUid = stream.uid(this.controllerUid);
    }
    static is(msg) {
        return msg.type === ModelHoveredInUIMessage.typestatic;
    }
}
ModelHoveredInUIMessage.typestatic = "ModelHoveredInUIMessage";
ModelHoveredInUIMessage.subjectstatic = "interaction";
MessageFactory.register(ModelHoveredInUIMessage);
/**
 * Announces that a model is hovered in the 3D scene.
 */
export class ModelHoveredIn3DMessage extends BusMessage {
    get byteLength() {
        return UID_SAFE_BYTES_PER_ELEMENT; // uid
    }
    constructor(modelUid) {
        super();
        this.modelUid = modelUid;
    }
    serialization(stream) {
        this.modelUid = stream.uidSafe(this.modelUid);
    }
    static is(msg) {
        return msg.type === ModelHoveredIn3DMessage.typestatic;
    }
}
ModelHoveredIn3DMessage.typestatic = "ModelHoveredIn3DMessage";
ModelHoveredIn3DMessage.subjectstatic = "interaction";
MessageFactory.register(ModelHoveredIn3DMessage);
/**
 * Requests a model selection update.
 */
export class RequestModelSelectionMessage extends BusMessage {
    get byteLength() {
        return UID_SAFE_BYTES_PER_ELEMENT;
    }
    constructor(uid) {
        super();
        this.uid = uid;
    }
    serialization(stream) {
        this.uid = stream.uidSafe(this.uid);
    }
    static is(msg) {
        return msg.type === RequestModelSelectionMessage.typestatic;
    }
}
RequestModelSelectionMessage.typestatic = "RequestModelSelectionMessage";
RequestModelSelectionMessage.subjectstatic = "interaction";
MessageFactory.register(RequestModelSelectionMessage);
/**
 * Announces that a remote peer clicked a model.
 */
export class RemoteModelClickedMessage extends BusMessage {
    get byteLength() {
        return UID_BYTES_PER_ELEMENT + Float32Array.BYTES_PER_ELEMENT * 3; // hitPoint
    }
    constructor(uid, hitPoint) {
        super();
        this.uid = uid;
        this.hitPoint = hitPoint;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
        this.hitPoint = stream.number3(this.hitPoint);
    }
    static is(msg) {
        return msg.type === RemoteModelClickedMessage.typestatic;
    }
}
RemoteModelClickedMessage.typestatic = "RemoteModelClickedMessage";
RemoteModelClickedMessage.subjectstatic = "interaction";
MessageFactory.register(RemoteModelClickedMessage);
/**
 * Reports hover state changes for a model.
 */
export class ModelHoverMessage extends BusMessage {
    get byteLength() {
        return (UID_BYTES_PER_ELEMENT +
            UID_BYTES_PER_ELEMENT + // controllerUid
            Float32Array.BYTES_PER_ELEMENT * 3); // hitPoint (world space)
    }
    constructor(uid, controllerUid, hitPoint) {
        super();
        this.uid = uid;
        this.controllerUid = controllerUid;
        this.hitPoint = hitPoint;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
        this.controllerUid = stream.uid(this.controllerUid);
        this.hitPoint = stream.number3(this.hitPoint);
    }
    static is(msg) {
        return msg.type === ModelHoverMessage.typestatic;
    }
}
ModelHoverMessage.typestatic = "ModelHoverMessage";
ModelHoverMessage.subjectstatic = "interaction";
MessageFactory.register(ModelHoverMessage);
export var ModelTouchState;
(function (ModelTouchState) {
    ModelTouchState[ModelTouchState["Start"] = 0] = "Start";
    ModelTouchState[ModelTouchState["Move"] = 1] = "Move";
    ModelTouchState[ModelTouchState["End"] = 2] = "End";
})(ModelTouchState || (ModelTouchState = {}));
// ToDo: maybe a array of touches with all touched controllers
/**
 * Reports touch-style interaction with a model.
 */
export class ModelTouchMessage extends BusMessage {
    get byteLength() {
        return (UID_BYTES_PER_ELEMENT +
            UID_BYTES_PER_ELEMENT + // controllerUid
            Uint8Array.BYTES_PER_ELEMENT + // state
            Float32Array.BYTES_PER_ELEMENT * 3 + // lastHitPoint
            Float32Array.BYTES_PER_ELEMENT * 3); // currHitPoint
    }
    constructor(uid, controllerUid, state, lastHitPoint, currHitPoint) {
        super();
        this.uid = uid;
        this.controllerUid = controllerUid;
        this.state = state;
        this.lastHitPoint = lastHitPoint;
        this.currHitPoint = currHitPoint;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
        this.controllerUid = stream.uid(this.controllerUid);
        this.state = stream.uint8(this.state);
        this.lastHitPoint = stream.number3(this.lastHitPoint);
        this.currHitPoint = stream.number3(this.currHitPoint);
    }
    static is(msg) {
        return msg.type === ModelTouchMessage.typestatic;
    }
}
ModelTouchMessage.typestatic = "ModelTouchMessage";
ModelTouchMessage.subjectstatic = "general";
MessageFactory.register(ModelTouchMessage);
